<script>
  import { onMount } from 'svelte';
  import { detailOnly } from './store'
  import Audio from './Audio.svelte';
  import Gallery from './Gallery.svelte';
  import Rollscanmodal from './Rollscanmodal.svelte';
  import Movie from './Movie.svelte';
  import Downloads from './Downloads.svelte';
  import Section from './Section.svelte';
  import PreviewImage from './PreviewImage.svelte';




  import l from "../scripts/utilities.js";
  let { detail } = $props();

// function openFs(cl) {

// }
  onMount(async() => {
    refreshFsLightbox();
    console.log('mounted')
  })
  function close() {
    detailOnly.set(0);
  }
</script>
<div class='detail-window'>
<div class="detail-header">
  <span class="roll-id">{detail.roll_id.c}</span> <span class="close"><button onclick={close}><span class="label">{l('close')}</span> <span class="icon">X</span></button></span>
</div>

<div class="detail-content">
  <span class="sup-title h-regular">{detail.composer.c}</span>
  <h1 class="h-bold"><span class="h-underline">{detail.title}</span></h1>

  <PreviewImage item={detail} />

  <div class="gallery">
    <span class="section-title">{l("gallery_title")}</span>
    {#if detail.gallery.audio}
      <Audio audio={detail} />
    {/if}
    {#if detail.gallery.rollscan}
      <Rollscanmodal item={detail} />

    {/if}
    {#if detail.gallery.images.length}


      <Gallery item={detail} />
    {/if}
    {#if detail.gallery.youtube}
      <Movie item={detail} />
    {/if}
  </div>



  <Section cssClass="gnd-data" items={detail.gnd_data} />
  <Section cssClass="tpl-data" items={detail.tpl_data} />
  <Section cssClass="details" items={detail.details} />



  <Downloads item={detail} title={l("download_title")} />


  <div class="more">
    <span class="section-title">{detail.additionals.t}</span>
    <div class="permalink">
      <a href={detail.permalink}>{l("permalink")}</a>
    </div>
    {#if detail.additionals.c != ''}
    <div class="content">{@html detail.additionals.c}</div>
    {/if}
  </div>

</div>
</div>
